import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  props: {
    items: {
      required: true,
      type: Array,
    },
    itemClass: {
      default: '',
    },
    arrowClass: {
      default: '',
    },
    isCheckout: {
      type: Boolean,
      default: false,
    },
    bigItem: {
      type: Boolean,
      default: false,
    },
    onlineReservation: {
      type: Boolean,
      default: false,
    }
  },
})
export default class BbHorizontalSliderComponent extends Vue {
  itemsToShow = 1;
  scrollIndex = 0;

  mounted() {
    this.calculateItemsToShow();
    this.orderByDiscount();
  }

  @Watch('items')
  resetPosition() {
    this.scrollIndex = 0;
  }

  get translateX() {
    return -(this.scrollIndex / this.itemsToShow) * 100;
  }

  get showLeftScroll() {
    return this.scrollIndex > 0;
  }

  get showRightScroll() {
    return this.scrollIndex < this.items.length - this.itemsToShow;
  }

  @Watch('items.length')
  itemsLengthChanged() {
    Vue.nextTick(() => {
      this.calculateItemsToShow();
    });
  }

  calculateItemsToShow() {
    const listElement = this.$refs.list;
    const firstChild = listElement.firstElementChild;
    if (firstChild) {
      this.itemsToShow = Math.round((
        listElement.offsetWidth / firstChild.offsetWidth
      ));
    } else {
      this.itemsToShow = 1;
    }
  }

  scrollLeft() {
    this.calculateItemsToShow();
    if (this.showLeftScroll) {
      this.scrollIndex -= 1;
    }
  }

  scrollRight() {
    this.calculateItemsToShow();
    if (this.showRightScroll) {
      this.scrollIndex += 1;
    }
  }

  orderByDiscount() {
    this.items.sort((a, b) => {
      if (a.discount) {
        return -1;
      }
      if (b.discount) {
        return 1;
      }
      return 0;
    });
  }
}
